<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
            :columns="['NOME', 'NOME DE USUÁRIO', 'EMAIL', 'ADMINISTRADOR', 'AÇÕES']"
            :showNew="true"
            :showReload="true"
            :showSearch="true"
            :showTipFooter="false"
            v-on:Search="onShowSearch"
            v-on:New="onNew"
            v-on:Load="onLoad"
            v-on:Reload="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.pessoa && obj.pessoa.nome ? obj.pessoa.nome.toUpperCase() : ''" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.username" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.pessoa && obj.pessoa.email ? obj.pessoa.email : 'NÃO INFORMADO  '" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.administrador ? 'SIM' : 'NÃO'" />
        <td class="row justify-content-around">
          <div v-if="obj.inative">
            <b-dropdown variant="link" size="sm" no-caret>
              <template slot="button-content">
                <i class="fa fa-lock-open cursor-pointer" style="color: black;" :title="$lang.Accounts.UnblockUserToolTip"></i>
              </template>
              <b-dropdown-header><strong>{{$lang.Accounts.ConfirmUnblockUser}}</strong></b-dropdown-header>
              <b-dropdown-item href="javascript:void(0);" v-on:click="changeUserStatus(obj, 'false')">{{$lang.Common.Yes}}</b-dropdown-item>
              <b-dropdown-item href="javascript:void(0);">{{$lang.Common.No}}</b-dropdown-item>
            </b-dropdown>
          </div>
          <div v-if="!obj.inative">
            <b-dropdown variant="link" size="sm" no-caret>
              <template slot="button-content">
                <i class="fas fa-ban text-third cursor-pointer" style="color: red;" :title="$lang.Accounts.BlockUserToolTip"></i>
              </template>
              <b-dropdown-header><strong>{{$lang.Accounts.ConfirmBlockUser}}</strong></b-dropdown-header>
              <b-dropdown-item href="javascript:void(0);" v-on:click="changeUserStatus(obj, 'true')">{{$lang.Common.Yes}}</b-dropdown-item>
              <b-dropdown-item href="javascript:void(0);">{{$lang.Common.No}}</b-dropdown-item>
            </b-dropdown>
          </div>
        </td>
      </tr>
    </Tables>
    <div class="row">
      <div class="col-12 pb-3 pl-4">
        <button type="button" class="btn btn-third btn-sm" v-on:click="$emit('New')" v-b-tooltip.hover :title="'Clique para cadastrar'"><i class="fas fa-user-plus"></i> <span class="d-md-down-none">&nbsp; Novo Usuário</span></button>
      </div>
    </div>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'

import AccountRepository from '@/shared/http/repositories/configurations/account.js'
import AccountSearchScreen from '../search/search.vue'
import { advancedOnException } from '@/components/tools/Utils'

export default {
  name: 'AccountList',
  mixins: [ActionsForm],
  data () {
    return {
      filters: null,
      data: null,
      form: null
    }
  },
  methods: {
    onNew () {
      this.$emit('New')
    },
    onLoad () {
      this.onLoadAll()
      this.$eventHub.on('Filter', ({ filters }) => {
        this.filters = filters
        this.$refs.tableGrid.Clear()
        this.$nextTick(() => {
          this.onLoadAll()
        })
      })
    },
    changeUserStatus (obj, status) {
      loading.push()
      let data = {
        inative: status
      }
      AccountRepository.ChangeStatus(obj.id, data)
        .then(() => {
          this.onLoadAll()
          loading.pop()
        })
        .catch(e => advancedOnException(e, this.$lang))
    },
    onLoadAll () {
      loading.push()
      if (this.filters) {
        AccountRepository.Search(this.filters.nome, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then((response) => {
            this.onResultGrid(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      } else {
        AccountRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then((response) => {
            this.onResultGrid(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
    },
    onShowSearch () {
      let aside = {
        title: 'Pesquisar',
        self: this,
        component: AccountSearchScreen
      }
      this.$eventHub.emit('Search', aside)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/account/components/list/accountlist.vue